import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Truck, FileText, Headphones, Mail } from "lucide-react";
import { toast } from "sonner";

const COLS = [
  {
    title: "Shop",
    links: [
      ["Mala", "/category/mala"],
      ["Vigrah / Deity", "/category/vigrah"],
      ["Pooja Samagri", "/category/pooja-samagri"],
      ["Bhagwan Vastra", "/category/bhagwan-vastra"],
      ["Books", "/category/books"],
      ["Braj Handicrafts", "/category/handicrafts"],
    ],
  },
  {
    title: "Marketplace",
    links: [
      ["B2B Wholesale", "/b2b"],
      ["Request Bulk Quote", "/b2b/request-quote"],
      ["Vendors", "/vendors"],
      ["Sell With Us", "/vendor/register"],
      ["Referral Program", "/referral"],
      ["Currency Exchange", "/currency-exchange"],
    ],
  },
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Contact", "/contact"],
      ["Blog & Knowledge", "/blog"],
      ["Vendor Policy", "/vendor-policy"],
    ],
  },
  {
    title: "Policies",
    links: [
      ["Terms & Conditions", "/terms"],
      ["Privacy Policy", "/privacy"],
      ["Refund Policy", "/refund-policy"],
      ["Shipping Policy", "/shipping-policy"],
    ],
  },
];

const TRUST = [
  [ShieldCheck, "Verified Vendors"],
  [Truck, "Pan India Delivery"],
  [FileText, "GST Invoice"],
  [Headphones, "Customer Support"],
];

export function Footer() {
  const [email, setEmail] = useState("");
  return (
    <footer className="mt-16 bg-[#1F1610] text-stone-300">
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {TRUST.map(([Icon, label]) => (
            <div key={label} className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-primary/15 text-primary grid place-items-center">
                <Icon size={20} />
              </div>
              <span className="text-sm font-medium text-stone-200">{label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 lg:grid-cols-6">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5 mb-3">
            <div className="h-10 w-10 rounded-xl bg-secondary text-white grid place-items-center font-serif font-bold text-lg">Sv</div>
            <div>
              <div className="font-serif font-bold text-lg text-white">Shri Vrindavan Shop</div>
              <div className="text-[11px] text-primary">Braj Ki Bhakti, Aapke Ghar Tak</div>
            </div>
          </div>
          <p className="text-sm text-stone-400 max-w-xs">
            India's digital marketplace for spiritual, pooja, Braj & Sanatan products. Connecting devotees with verified artisans and vendors.
          </p>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (email) {
                toast.success("Subscribed! Thank you.");
                setEmail("");
              }
            }}
            className="mt-5 flex rounded-full bg-white/10 overflow-hidden max-w-xs"
          >
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              required
              data-testid="footer-newsletter-input"
              placeholder="Your email"
              className="flex-1 bg-transparent px-4 py-2.5 text-sm outline-none placeholder:text-stone-500"
            />
            <button data-testid="footer-newsletter-submit" className="px-4 bg-primary text-primary-foreground">
              <Mail size={16} />
            </button>
          </form>
        </div>

        {COLS.map((col) => (
          <div key={col.title}>
            <h4 className="font-semibold text-white text-sm mb-3">{col.title}</h4>
            <ul className="space-y-2">
              {col.links.map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="text-sm text-stone-400 hover:text-primary transition-colors">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-stone-500">
          <p>© {new Date().getFullYear()} Shri Vrindavan Shop. All rights reserved.</p>
          <p data-testid="footer-tagline">Braj Ki Bhakti, Aapke Ghar Tak</p>
        </div>
      </div>
    </footer>
  );
}
